// Signature: 0f38a49a6f99c72fc228861a258bbd74cce7b8bd471c52f7f62c77996d45545d
/*
    Этот файл был создан автоматически.
    НЕ ИЗМЕНЯЙТЕ ЕГО ВРУЧНУЮ!
    Вместо изменения вручную используйте `easy-breezy`
*/
import { createApi, baseQuery, enhanceEndpoints, injectEndpoints } from './extension';
import type * as v1StatusesGet from './v1/statuses/get';
import type * as v1SuppliersAppealsAttachmentsPost from './v1/suppliers/appeals/attachments/post';
import type * as v1SuppliersAppealsAttachmentsBucketIdKeyIdGet from './v1/suppliers/appeals/attachments/{bucket_id}/{key_id}/get';
import type * as v1SuppliersDialogsGet from './v1/suppliers/dialogs/get';
import type * as v1SuppliersDialogsDialogIdGet from './v1/suppliers/dialogs/{dialog_id}/get';
import type * as v1SuppliersUsersAppealsPost from './v1/suppliers/users/appeals/post';
import type * as v1SuppliersUsersAppealsAppealIdFeedbacksPost from './v1/suppliers/users/appeals/{appeal_id}/feedbacks/post';
import type * as v1SuppliersUsersAppealsAppealIdPatch from './v1/suppliers/users/appeals/{appeal_id}/patch';
import type * as v3ThemesGet from './v3/themes/get';

export const base = createApi({
    reducerPath: 'api/call-center',
    baseQuery  : baseQuery('/api/suppliers-communication-api'),
    endpoints  : (build) => ({
        v1StatusesGet: build.query<v1StatusesGet.TResponse, void>({
            query: () => ({
                method: 'GET',
                url   : '/v1/statuses'
            })
        }),
        v1SuppliersAppealsAttachmentsBucketIdKeyIdGet: build.query<v1SuppliersAppealsAttachmentsBucketIdKeyIdGet.TResponse, v1SuppliersAppealsAttachmentsBucketIdKeyIdGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : `/v1/suppliers/appeals/attachments/${params.path.bucket_id}/${params.path.key_id}`
            })
        }),
        v1SuppliersAppealsAttachmentsPost: build.mutation<v1SuppliersAppealsAttachmentsPost.TResponse, v1SuppliersAppealsAttachmentsPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v1/suppliers/appeals/attachments',
                body  : params.body
            })
        }),
        v1SuppliersDialogsDialogIdGet: build.query<v1SuppliersDialogsDialogIdGet.TResponse, v1SuppliersDialogsDialogIdGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : `/v1/suppliers/dialogs/${params.path.appeal_id}`
            })
        }),
        v1SuppliersDialogsGet: build.query<v1SuppliersDialogsGet.TResponse, v1SuppliersDialogsGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v1/suppliers/dialogs',
                params: {
                    dCreateFrom: params?.query?.dCreateFrom,
                    dCreateTo  : params?.query?.dCreateTo,
                    statusIds  : params?.query?.statusIds,
                    themeIds   : params?.query?.themeIds,
                    offset     : params?.query?.offset,
                    limit      : params?.query?.limit,
                    sort       : params?.query?.sort,
                    destination: params?.query?.destination
                }
            })
        }),
        v1SuppliersUsersAppealsAppealIdFeedbacksPost: build.mutation<v1SuppliersUsersAppealsAppealIdFeedbacksPost.TResponse, v1SuppliersUsersAppealsAppealIdFeedbacksPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : `/v1/suppliers/users/appeals/${params.path.appeal_id}/feedbacks`,
                body  : {
                    feedback_point: params?.body?.feedback_point,
                    feedback_stars: params?.body?.feedback_stars,
                    feedback_text : params?.body?.feedback_text
                }
            })
        }),
        v1SuppliersUsersAppealsAppealIdPatch: build.mutation<v1SuppliersUsersAppealsAppealIdPatch.TResponse, v1SuppliersUsersAppealsAppealIdPatch.IParameters>({
            query: (params) => ({
                method: 'PATCH',
                url   : `/v1/suppliers/users/appeals/${params.path.appeal_id}`,
                body  : {
                    appeal_text  : params?.body?.appeal_text,
                    attachments  : params?.body?.attachments,
                    attr         : params?.body?.attr,
                    id           : params?.body?.id,
                    is_close     : params?.body?.is_close,
                    parent_com_id: params?.body?.parent_com_id,
                    supplier_id  : params?.body?.supplier_id,
                    theme_id     : params?.body?.theme_id,
                    upload_ids   : params?.body?.upload_ids,
                    user_id      : params?.body?.user_id
                }
            })
        }),
        v1SuppliersUsersAppealsPost: build.mutation<v1SuppliersUsersAppealsPost.TResponse, v1SuppliersUsersAppealsPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v1/suppliers/users/appeals/',
                body  : {
                    appealText  : params?.body?.appealText,
                    attachments : params?.body?.attachments,
                    attr        : params?.body?.attr,
                    country_name: params?.body?.country_name,
                    parentComId : params?.body?.parentComId,
                    themeId     : params?.body?.themeId
                }
            })
        }),
        v3ThemesGet: build.query<v3ThemesGet.TResponse, void>({
            query: () => ({
                method: 'GET',
                url   : '/v3/themes'
            })
        })
    })
});
export const api = injectEndpoints(base);
enhanceEndpoints(api);

export default api;
